import { render, staticRenderFns } from "./ImageEffectSelectedBody.vue?vue&type=template&id=130ac94c&scoped=true"
import script from "./ImageEffectSelectedBody.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageEffectSelectedBody.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ImageEffectSelectedBody.vue?vue&type=style&index=0&id=130ac94c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130ac94c",
  null
  
)

export default component.exports